import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/1percent.svg")